import { useTranslation } from 'react-i18next';
import './ButtonsStyle.css';

export const SubmitButton = () => {
    const { t } = useTranslation();
    return (
        <button type="submit" className={'button--main primary-button'}>
            {t('common:buttons.save')}
        </button>
    );
};
